export const getTooltipKey = key => `${key}.tooltip`;
